import React from 'react'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import KanBoIcon from 'components/KanBoIcon'
import {
  ModalMenu
} from 'components/Modal'
import {
  MenuItem as ModalMenuItem
} from 'components/Menu'
import { HeaderButton } from 'components/Sidebar'
import menuItemClasses from 'components/Menu/components/MenuItem/MenuItem.module.scss'
import { injectIntl, FormattedMessage } from 'react-intl'
import sweetalert from 'sweetalert2'
import Settings from '../../Sidebar/Settings'
import MoveCard from '../../Sidebar/MoveCard'
import CopyCard from '../../Sidebar/CopyCard'
import CreateCard from '../../Sidebar/CreateCard'
import CreateTemplate from '../../Sidebar/CreateTemplate'
import ApplyTemplate from '../../Sidebar/ApplyTemplate'
import BlockCard from '../../Sidebar/BlockCard'
import { withBoardPermission } from 'dataProviders/Board'
import Clipboard from 'react-clipboard.js'
import GetIncomingMailPublicAddress from './GetIncomingMailPublicAddress'
import { ModalBoardContext, ModalCardContext } from 'components/Modal'
import SelectBlocker from '../../CardBlockerForm/SelectBlocker'
import styled from 'styled-components'

const MenuButton = styled(HeaderButton)`
  margin-left: .5em;
`

export class Menu extends React.Component {
  handleSettingsClick = () => {
    this.props.leftSidebar.push(() => <ModalCardContext cardId={this.props.id}><Settings cardId={this.props.id} /></ModalCardContext>)
  }

  handleMoveClick = () => {
    this.props.leftSidebar.push((props) => <ModalCardContext cardId={this.props.id}><MoveCard {...props} cardId={this.props.id} /></ModalCardContext>)
  }

  handleArchiveClick = () => {
    const {
      id,
      isArchived,
      name,
      intl,
      requestArchiveCard,
      requestUnarchiveCard
    } = this.props

    if (!isArchived) {
      sweetalert({
        text: intl.formatMessage({
          id: 'CARD_ARCHIVE_QUESTION'
        }, {
          name
        }),
        confirmButtonText: intl.formatMessage({ id: 'CARD_ARCHIVE' }),
        cancelButtonText: intl.formatMessage({ id: 'CANCEL' }),
        showCancelButton: true,
        type: 'question'
      }).then(() => {
        requestArchiveCard({
          cardId: id
        })
      }, () => {})
    } else {
      requestUnarchiveCard({
        cardId: id
      })
    }
  }

  handleCopyClick = () => {
    const {
      leftSidebar,

      id,
      isTemplate,
    } = this.props

    leftSidebar.push(() =>
      <ModalCardContext cardId={this.props.id}>
        <CopyCard cardId={id} title={<FormattedMessage id={isTemplate ? 'CARD_TEMPLATE_COPY' : 'CARD_COPY_HEADER'} />} />
      </ModalCardContext>
    )
  }

  handleCreateCardClick = () => {
    this.props.leftSidebar.push(() => <ModalCardContext cardId={this.props.id}><CreateCard cardId={this.props.id} /></ModalCardContext>)
  }

  handleCreateTemplateClick = () => {
    this.props.leftSidebar.push(() => <ModalCardContext cardId={this.props.id}><CreateTemplate cardId={this.props.id} /></ModalCardContext>)
  }

  handleApplyTemplateClick = () => {
    this.props.leftSidebar.push((props) => <ModalCardContext cardId={this.props.id}><ApplyTemplate {...props} cardId={this.props.id} /></ModalCardContext>)
  }

  handleDeleteClick = () => {
    const { intl, id, name, requestDeleteCard } = this.props

    sweetalert({
      text: intl.formatMessage({
        id: 'CARD_DELETE_QUESTION'
      }, {
        name
      }),
      confirmButtonText: intl.formatMessage({ id: 'DELETE' }),
      cancelButtonText: intl.formatMessage({ id: 'CANCEL' }),
      showCancelButton: true,
      type: 'warning',
      confirmButtonClass: 'btn btn-warning'
    }).then(() => {
      requestDeleteCard({
        cardId: id
      })
    }, () => {})
  }

  handleFollowClick = () => {
    const { id, isObserved, requestFollowCard } = this.props

    requestFollowCard({
      cardId: id,
      isObserved: !isObserved
    })
  }

  handleSelectBlocker = (blockerId) => {
    this.props.leftSidebar.pop()

    this.props.leftSidebar.push(() =>
      <ModalBoardContext boardId={this.props.boardId}>
        <ModalCardContext cardId={this.props.id}>
          <BlockCard
            blockerId={blockerId}
          />
        </ModalCardContext>
      </ModalBoardContext>
    )
  }

  handleBlockClick = () => {
    this.props.leftSidebar.push(() =>
      <ModalBoardContext boardId={this.props.boardId}>
        <ModalCardContext cardId={this.props.id}>
          <SelectBlocker
            onSelect={this.handleSelectBlocker}
          />
        </ModalCardContext>
      </ModalBoardContext>
    )
  }

  render () {
    const {
      intl,
      permission,
      id,
      isArchived,
      isObserved,
      allowCardRemove,
      incomingMailsEnabled,
      isTemplate,
      isBoardTemplate,
      isCompleted,
    } = this.props

    const showSettings = (
      !isArchived &&
      permission.member &&
      incomingMailsEnabled &&
      !isTemplate &&
      !isBoardTemplate
    )

    return (
      <ModalMenu>
        <MenuButton
          icon={<KanBoIcon name='kanbo-16-options' style={{ fontSize: 16 }} />}
        />
        {(showSettings) && (
          <ModalMenuItem header>
            <FormattedMessage id='CARD' />
          </ModalMenuItem>
        )}
        {showSettings &&
          <GetIncomingMailPublicAddress />
        }
        <li>
          <Clipboard
            component='a'
            data-clipboard-text={`${window.location.origin}/card/${id}`}
            onSuccess={() => {
              sweetalert({
                type: 'success',
                text: intl.formatMessage({ id: 'LINK_COPIED_TO_CLIPBOARD' }),
                timer: 1000,
                showConfirmButton: false
              }).catch(sweetalert.noop)
            }}
          >
            <KanBoIcon name='kanbo-16-link' className={menuItemClasses.icon} />
            <FormattedMessage id='CARD_GET_LINK' />
          </Clipboard>
        </li>
        {showSettings &&
          <ModalMenuItem
            icon={<KanBoIcon name='kanbo-24-settings' />}
            onClick={this.handleSettingsClick}
          >
            <FormattedMessage id='SETTINGS' />
          </ModalMenuItem>
        }
        <ModalMenuItem divider />
        <ModalMenuItem header>
          <FormattedMessage id='ACTIONS' />
        </ModalMenuItem>
        <ModalMenuItem
          icon={<KanBoIcon name={!isObserved ? 'kanbo-24-following' : 'kanbo-24-unfollowing'} />}
          onClick={this.handleFollowClick}
        >
          <FormattedMessage id={!isObserved ? 'FOLLOW' : 'UNFOLLOW'} />
        </ModalMenuItem>
        {(!isTemplate && !isArchived && permission.member) &&
          <ModalMenuItem
            icon={<KanBoIcon name='kanbo-24-move' />}
            onClick={this.handleMoveClick}
          >
            <FormattedMessage id='CARD_MOVE_HEADER' />
          </ModalMenuItem>
        }
        {(!isTemplate && permission.member) &&
          <ModalMenuItem
            icon={<KanBoIcon name={!isArchived ? 'kanbo-24-archive' : 'kanbo-24-send-to-board'} />}
            onClick={this.handleArchiveClick}
          >
            <FormattedMessage id={!isArchived ? 'CARD_ARCHIVE' : 'CARD_UNARCHIVE'} />
          </ModalMenuItem>
        }
        {(!isTemplate && !isArchived && !isCompleted && permission.member) &&
          <ModalMenuItem
            icon={<KanBoIcon name='kanbo-16-block' />}
            onClick={this.handleBlockClick}
          >
            <FormattedMessage id='BLOCKERS_CARD_BLOCK' />
          </ModalMenuItem>
        }
        {(!isArchived && permission.member) &&
          <ModalMenuItem
            icon={<KanBoIcon name='kanbo-16-copy-card' />}
            onClick={this.handleCopyClick}
          >
            <FormattedMessage id={isTemplate ? 'CARD_TEMPLATE_COPY' : 'CARD_COPY_HEADER'} />
          </ModalMenuItem>
        }
        {(!isArchived && permission.member) && (
          isTemplate ? (
            <ModalMenuItem
              icon={<KanBoIcon name='kanbo-16-template' />}
              onClick={this.handleCreateCardClick}
            >
              <FormattedMessage id='CARD_CREATE_HEADER' />
            </ModalMenuItem>
          ) : (
            <ModalMenuItem
              icon={<KanBoIcon name='kanbo-16-template' />}
              onClick={this.handleCreateTemplateClick}
            >
              <FormattedMessage id='CARD_TEMPLATE_HEADER' />
            </ModalMenuItem>
          )
        )}
        {(!isArchived && permission.member) &&
          <ModalMenuItem
            icon={<KanBoIcon name='kanbo-16-template' />}
            onClick={this.handleApplyTemplateClick}
          >
            <FormattedMessage id='CARD_APPLY_TEMPLATE_HEADER' />
          </ModalMenuItem>
        }
        {(allowCardRemove && permission.member) &&
          <ModalMenuItem
            icon={<KanBoIcon name='kanbo-16-delete' />}
            onClick={this.handleDeleteClick}
          >
            <FormattedMessage id='DELETE' />
          </ModalMenuItem>
        }
      </ModalMenu>
    )
  }
}

export default injectIntl(withLeftSidebar(withBoardPermission(Menu)))
